import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/api/apiClient";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, X, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setError("No verification token provided");
      return;
    }

    api.auth.emails.verify(token)
      .then((res) => {
        setStatus("success");
        setEmail(res.email);
      })
      .catch((err) => {
        setStatus("error");
        setError(err.message || "Verification failed");
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <Card className="w-full max-w-md border border-gray-200 shadow-sm">
        <CardContent className="p-8 text-center space-y-4">
          {status === "loading" && (
            <>
              <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto" />
              <h2 className="text-lg font-semibold">Verifying your email...</h2>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <Check className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-lg font-semibold text-green-900">Email Verified</h2>
              <p className="text-sm text-gray-600">
                <strong>{email}</strong> has been verified and added to your account.
              </p>
              <Button
                onClick={() => navigate("/profile/account")}
                className="bg-[rgb(var(--brand-yellow))] hover:bg-[rgb(var(--brand-yellow-hover))] text-black font-semibold rounded-xl"
              >
                Go to Profile
              </Button>
            </>
          )}

          {status === "error" && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto">
                <X className="w-8 h-8 text-red-600" />
              </div>
              <h2 className="text-lg font-semibold text-red-900">Verification Failed</h2>
              <p className="text-sm text-gray-600">{error}</p>
              <Button
                onClick={() => navigate("/profile/account")}
                variant="outline"
                className="rounded-xl"
              >
                Go to Profile
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
